import OwButton from "../../shared/OwButton/OwButton";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import { IMinimumOrderDisplayAmounts } from "../../../services/MinimumOrderService";

type Props = {
    amounts: IMinimumOrderDisplayAmounts;
    confirmFn: () => void;
    cancelFn: () => void;
};

/**
 * Supplier-user confirmation before submitting an order that is below the supplier's minimum order total.
 * Confirming sends `override_min_order_total: true`, which the API honors only for supplier users.
 */
const MinOrderTotalOverrideModal = (props: Props) => {
    return (
        <div className="MinOrderTotalOverrideModal p-4">
            <div className="mb-4 text-center">
                <OwTranslate
                    id={"min_order_total_override_confirm"}
                    defaultMessage={"This order is below the minimum order total of {minimum} ({shortfall} short). Submit it anyway?"}
                    values={{ minimum: props.amounts.minimum, shortfall: props.amounts.shortfall }}
                />
            </div>

            <div className={"d-flex justify-content-center gap-2"}>
                <OwButton title={"submit"} className={"btn-warning"} fn={props.confirmFn} />
                <OwButton title={"cancel"} className={"btn-danger"} fn={props.cancelFn} />
            </div>
        </div>
    );
};

export default MinOrderTotalOverrideModal;
